import apiSlice from "../store/slices";
import endpoints from "./endpoints";

const {
  profileApis: { appSettings },
} = endpoints;

// Static app configuration from the backend. `loaderMessages` is the promo text
// shown below the loader animation (e.g. NFO/marketing copy). The endpoint is
// public and does not require authentication.
export interface AppSettings {
  loaderMessages: string;
}

interface AppSettingsResponse {
  status: "success" | "error";
  message?: string;
  data?: {
    loaderMessages?: string | null;
  };
}

const appSettingsApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAppSettings: builder.query<AppSettings, void>({
      query: () => ({
        url: appSettings,
        method: "GET",
      }),
      transformResponse: (response: AppSettingsResponse): AppSettings => ({
        // Trim and default to empty so the loader simply shows no text when the
        // backend sends nothing.
        loaderMessages: String(response?.data?.loaderMessages ?? "").trim(),
      }),
      // Static config — keep the cached value for the whole session (1 hour) so it
      // is fetched once and reused by every loader without refetching.
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetAppSettingsQuery } = appSettingsApi;

export default appSettingsApi;
